import { useState } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import Countries from '../countries';
import { FaPencilAlt, FaTrashAlt, FaExclamation } from 'react-icons/fa';
import { IoCloseSharp } from 'react-icons/io5';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import { useEffect } from 'react';
import Usuarios from '../components/Usuarios/Usuarios';
import CreateCliente from '../components/Usuarios/CreateCliente';
import { isAuthenticated } from '../../src/index'
import notifications from '../components/notifications';
import Agendamentos, { openModal } from '../components/agendamentos';
import { format, parseISO } from 'date-fns';

function Monitorar() {
  /* Inicializa o objeto que contem todos os países para o .map */
  const [countriesList, setCountriesList] = useState(Countries);
  /* Inicializa o objeto que contem quem possui uma pendencia p resolver */
  const [pendenciaOn, setPendenciaOn] = useState([]);
  /* Inicializa variável responsável por dizer qual notificação vai aparecer. */
  const [notificationType, setNotificationType] = useState(0);
  let pickDate = new Date();
  let pickDatePlus = new Date();
  pickDatePlus.setDate(pickDatePlus.getDate() + 90);
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const { authenticated, userPermission, userStatus, timestamp, userLogin, userId } = isAuthenticated();

  /* Variáveis de cadastro */
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [grupo, setGrupo] = useState("");
  const [cidade, setCidade] = useState([]);
  const [limiteAntecedencia, setLimiteAntecedencia] = useState("0");
  const [anoMarcado, setAnoMarcado] = useState(pickDatePlus.getFullYear());
  const [mesMarcado, setMesMarcado] = useState(addZeroes(pickDatePlus.getMonth() + 1, 2));
  const [diaMarcado, setDiaMarcado] = useState(addZeroes(pickDatePlus.getDate(), 2));
  const [anoBloqueado, setAnoBloqueado] = useState(pickDate.getFullYear());
  const [mesBloqueado, setMesBloqueado] = useState(addZeroes(pickDate.getMonth() + 1, 2));
  const [diaBloqueado, setDiaBloqueado] = useState(addZeroes(pickDate.getDate(), 2));
  const [obs, setObs] = useState("");
  const [pais, setPais] = useState("pt-br");
  const [conta, setConta] = useState("");
  const [status, setStatus] = useState(0);
  const [vendedor, setVendedor] = useState("0");
  const [ClienteId, setClienteId] = useState("");
  /* Novas variáveis de cadastro AUXILIAR */
  const [userIdMonitorar, setuserIdMonitorar] = useState(0);
  const [newLogin, setNewLogin] = useState("");
  const [newSenha, setNewSenha] = useState("");
  const [newGrupo, setNewGrupo] = useState("");
  const [newCidade, setNewCidade] = useState([]);
  const [newLimiteAntecedencia, setNewLimiteAntecedencia] = useState("");
  const [newAnoMarcado, setNewAnoMarcado] = useState("");
  const [newMesMarcado, setNewMesMarcado] = useState("");
  const [newDiaMarcado, setNewDiaMarcado] = useState("");
  const [newAnoBloqueado, setNewAnoBloqueado] = useState("");
  const [newMesBloqueado, setNewMesBloqueado] = useState("");
  const [newDiaBloqueado, setNewDiaBloqueado] = useState("");
  const [newObs, setNewObs] = useState("");
  const [newPais, setNewPais] = useState("pt-br");
  const [newConta, setNewConta] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [newVendedor, setNewVendedor] = useState("");
  /* Variáveis comprovante */
  const [comprovanteLogin, setcomprovanteLogin] = useState("");
  const [comprovanteSenha, setcomprovanteSenha] = useState("");
  const [comprovanteGrupo, setcomprovanteGrupo] = useState("");
  const [comprovanteCidade, setcomprovanteCidade] = useState([]);
  const [comprovanteLimiteAntecedencia, setcomprovanteLimiteAntecedencia] = useState("");
  const [comprovanteAnoMarcado, setcomprovanteAnoMarcado] = useState("");
  const [comprovanteMesMarcado, setcomprovanteMesMarcado] = useState("");
  const [comprovanteDiaMarcado, setcomprovanteDiaMarcado] = useState("");
  const [comprovanteAnoBloqueado, setcomprovanteAnoBloqueado] = useState("");
  const [comprovanteMesBloqueado, setcomprovanteMesBloqueado] = useState("");
  const [comprovanteDiaBloqueado, setcomprovanteDiaBloqueado] = useState("");
  const [comprovanteObs, setcomprovanteObs] = useState("");
  const [comprovanteStatus, setcomprovanteStatus] = useState("");
  const [nomeClienteComprovante, setNomeClienteComprovante] = useState("");
  const [contatoClienteComprovante, setContatoClienteComprovante] = useState("");

  /* Variável Captura de Clientes */
  const [listaClientesAtivos, setListaClientesAtivos] = useState("");
  const [listaClientesHibernados, setListaClientesHibernados] = useState("");
  const [listaClientesFinalizados, setListaClientesFinalizados] = useState("");

  /* Variáveis para Filtro */
  const [filtroGrupo, setFiltroGrupo] = useState(-1);
  const [filtroCidade, setFiltroCidade] = useState(-1);
  const [filtroStatus, setFiltroStatus] = useState(-1);
  const [usersList, setUsersList] = useState([]);

  const [openCloseEditStatus, setOpenCloseEditStatus] = useState(false);
  const [estadoDuplicados, setEstadoDuplicados] = useState(false);
  const [comprovanteEnviado, setComprovanteEnviado] = useState(false);
  const [textoBotaoDuplicados, setTextoBotaoDuplicados] = useState("Exibir Duplicados");

  const [clientesList, setClientesList] = useState([]);
  const [parceirosList, setParceirosList] = useState([]);
  const [showAllClientes, setShowAllClientes] = useState(false);

  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  const [clienteDetails, setClienteDetails] = useState(null);
  const cidades = {
    54: 'Brasília',
    55: 'Rio de Janeiro',
    56: 'São Paulo',
    57: 'Recife',
    128: 'Porto Alegre'
  };

  function revelarNomesCidades(cidadeCodigos) {
    return cidadeCodigos.map(codigo => cidades[codigo]).join(', ');
  }

  async function getClienteDetails(clienteID) {


    try {
      console.log("tentando puxa infos")
      console.log("ClienteID:", clienteID);
      const response = await api.get(`/clienteAgiliza/${clienteID}`);
      setClienteDetails(response.data);
      setNomeClienteComprovante(response.data.Nome)
      setContatoClienteComprovante(response.data.contato)
      console.log("infos seguidas" + response.data.Nome)
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }

  const sendItemsToEdit = async (userData) => {
    setuserIdMonitorar(userData.id);
    setNewLogin(userData.login);
    setNewSenha(userData.senha);
    setNewGrupo(userData.grupo);
    setNewLimiteAntecedencia(userData.limiteAntecedencia);
    setNewAnoMarcado(userData.anoMarcado);
    setNewMesMarcado(userData.mesMarcado);
    setNewDiaMarcado(userData.diaMarcado);
    setNewAnoBloqueado(userData.anoBloqueado);
    setNewMesBloqueado(userData.mesBloqueado);
    setNewDiaBloqueado(userData.diaBloqueado);
    setNewObs(userData.obs);
    setNewPais(userData.pais);
    setNewConta(userData.conta);
    setNewStatus(userData.status);
    setNewVendedor(userData.vendedor);
    try {
      const newCitiesSplitted = userData.cidade.split(",");
      setNewCidade(newCitiesSplitted);
    } catch (TypeError) {
      setNewCidade(userData.cidade);
    }
    await sleep(10);
    try {
      let newCheckBox1 = document.getElementById("newCheckBox1");
      let newCheckBox2 = document.getElementById("newCheckBox2");
      let newCheckBox3 = document.getElementById("newCheckBox3");
      let newCheckBox4 = document.getElementById("newCheckBox4");
      let newCheckBox5 = document.getElementById("newCheckBox5");
      if (userData.cidade.includes("54") === true) {
        newCheckBox1.checked = true;
      }
      if (userData.cidade.includes("56") === true) {
        newCheckBox2.checked = true;
      }
      if (userData.cidade.includes("128") === true) {
        newCheckBox3.checked = true;
      }
      if (userData.cidade.includes("55") === true) {
        newCheckBox4.checked = true;
      }
      if (userData.cidade.includes("57") === true) {
        newCheckBox5.checked = true;
      }
    } catch (error) {
      console.log("erro no sendItemsToEdit")
    }
  }
  const updateNewData = async (id) => {
    if (validateNewForm() === true) {
      const res = await api.post('/updateUser', {
        id: id,
        login: newLogin,
        senha: newSenha,
        grupo: newGrupo,
        cidade: newCidade,
        limiteAntecedencia: newLimiteAntecedencia,
        anoMarcado: newAnoMarcado,
        mesMarcado: newMesMarcado,
        diaMarcado: newDiaMarcado,
        anoBloqueado: newAnoBloqueado,
        mesBloqueado: newMesBloqueado,
        diaBloqueado: newDiaBloqueado,
        obs: newObs,
        pais: newPais,
        conta: newConta,
        status: newStatus,
        vendedor: newVendedor,
        ClienteId: ClienteId
      });

      console.log("aqui")
      console.log(res.data)
      if (res.data.status === true) {
        let newData = [];
        newData = filteredData.map(item => {
          if (item.id === id) {
            return {
              ...item,
              id: id,
              login: newLogin,
              senha: newSenha,
              grupo: newGrupo,
              cidade: newCidade,
              limiteAntecedencia: newLimiteAntecedencia,
              anoMarcado: newAnoMarcado,
              mesMarcado: newMesMarcado,
              diaMarcado: newDiaMarcado,
              anoBloqueado: newAnoBloqueado,
              mesBloqueado: newMesBloqueado,
              diaBloqueado: newDiaBloqueado,
              obs: newObs,
              pais: newPais,
              conta: newConta,
              status: newStatus,
              vendedor: newVendedor,
              ClienteId: ClienteId
            }
          }
          return item;
        });
        setFilteredData(newData);
        setUsersList(newData);
        setNotificationType(8);
        getUsers()
        setOpenCloseEditStatus(!openCloseEditStatus)
      } else {
        setNotificationType(9);
      }
    } else {
      setNotificationType(10);
    }
  }
  async function getUsers() {
    const res = await api.get('/clientes?userPermission=99&CPF=05204993010');
    const resCliente = await api.get('/clientesAgiliza');
    const resParceiro = await api.get('/clientesParceiros');
    setParceirosList(resParceiro.data);
    setClientesList(resCliente.data);
    setUsersList(res.data);

  }

  const getVendedoresProdutores = async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');
      // Verifica se a resposta possui a chave `data`
      if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
        const users = resVendedoresProdutores.data.data;
        // console.log('Vendedores e Produtores carregados:', users);
        setVendedoresList(users.filter(user => user.is_vendedor === 1));
        setProdutoresList(users.filter(user => user.is_produtor === 1));
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  }


  useEffect(() => {
    if (userPermission === 1) {
      setVendedor(userStatus)
    }
    getVendedoresProdutores();

    getUsers();
  }, []);
  /* Insere os dados somente se todos os campos requeridos estiverem preenchidos. */

  const deleteUser = async (id) => {
    const res = await api.post('/deletar', {
      id: id
    });
    if (res.data === true) {
      const newItems = usersList.filter(item => item.id !== id);
      setUsersList(newItems);
      setNotificationType(4);
    } else {
      setNotificationType(5);
    }
  }
  function addZeroes(num, len) {
    var numberWithZeroes = String(num);
    var counter = numberWithZeroes.length;
    while (counter < len) {
      numberWithZeroes = "0" + numberWithZeroes;
      counter++;
    }
    return numberWithZeroes;
  }

  /* Notificações Customizadas */
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);
  /* Faz a verificação de todos os campos para saber se estão vazios ou preenchidos. */
  const validateForm = () => {
    if (vendedor === "" || login === "" || senha === "" || cidade.length === 0 || anoMarcado === "" || mesMarcado === "" || diaMarcado === "" || anoBloqueado === "" || mesBloqueado === "" || diaBloqueado === "" || grupo === "" || ClienteId === "") {
      // if (login === "" || senha === "" || conta === "" || cidade.length === 0 || anoMarcado === "" || mesMarcado === "" || diaMarcado === "" || anoBloqueado === "" || mesBloqueado === "" || diaBloqueado === "" || grupo === "") {
      return false;
    }
    return true;
  }
  const validateNewForm = () => {
    if (newVendedor === "" || newLogin === "" || newSenha === "" || newCidade.length === 0 || newAnoMarcado === "" || newMesMarcado === "" || newDiaMarcado === "" || newAnoBloqueado === "" || newMesBloqueado === "" || newDiaBloqueado === "" || newGrupo === "") {
      // if (newLogin === "" || newSenha === "" || newConta === "" || newCidade.length === 0 || newAnoMarcado === "" || newMesMarcado === "" || newDiaMarcado === "" || newAnoBloqueado === "" || newMesBloqueado === "" || newDiaBloqueado === "" || newGrupo === "") {
      return false;
    }
    return true;
  }
  /* Insere os dados somente se todos os campos requeridos estiverem preenchidos. */
  const insertData = async () => {
    if (validateForm() === true) {
      if (grupo == 1) {
        setcomprovanteGrupo("INDIVIDUAL")
      } else if (grupo == 2) {
        setcomprovanteGrupo("GRUPO")
      } else if (grupo => 2 && grupo <= 10) {
        setcomprovanteGrupo(`GRUPO DE ${grupo}`)
      }
      else {
        setcomprovanteGrupo("GRUPO MAIOR QUE 10 OU ERRO!")
      }
      setcomprovanteCidade(cidade)
      setcomprovanteLimiteAntecedencia(limiteAntecedencia)
      setcomprovanteAnoMarcado(anoMarcado)
      setcomprovanteMesMarcado(addZeroes(mesMarcado, 2))
      setcomprovanteDiaMarcado(addZeroes(diaMarcado, 2))
      setcomprovanteAnoBloqueado(anoBloqueado)
      setcomprovanteMesBloqueado(addZeroes(mesBloqueado, 2))
      setcomprovanteDiaBloqueado(addZeroes(diaBloqueado, 2))
      setcomprovanteObs(obs)
      if (status == 0) {
        setcomprovanteStatus("Ativo na fila")
      } else if (status == 1) {
        setcomprovanteStatus("Quarentena")
      } else if (status == 2) {
        setcomprovanteStatus("Finalista")
      } else {
        setcomprovanteStatus("erro!")
      }
      const res = await api.post('/cadastrar', {
        login,
        senha,
        grupo,
        cidade,
        limiteAntecedencia,
        anoMarcado,
        mesMarcado,
        diaMarcado,
        anoBloqueado,
        mesBloqueado,
        diaBloqueado,
        obs,
        pais,
        conta,
        status,
        vendedor,
        ClienteId
      });
      if (res.data.status === true) {
        const newUser = {
          id: res.data.insertId,
          login: login,
          senha: senha,
          grupo: grupo,
          cidade: cidade,
          limiteAntecedencia: limiteAntecedencia,
          anoMarcado: anoMarcado,
          mesMarcado: mesMarcado,
          diaMarcado: diaMarcado,
          anoBloqueado: anoBloqueado,
          mesBloqueado: mesBloqueado,
          diaBloqueado: diaBloqueado,
          obs: obs,
          pais: pais,
          conta: conta,
          vendedor: vendedor,
          status: 0,
          ClienteId: ClienteId,
        }
        setUsersList([...usersList, newUser]);
        pickDate = new Date();
        pickDatePlus = new Date();
        pickDatePlus.setDate(pickDatePlus.getDate() + 90);
        setAnoMarcado(pickDatePlus.getFullYear());
        setMesMarcado(addZeroes(pickDatePlus.getMonth() + 1, 2));
        setDiaMarcado(addZeroes(pickDatePlus.getDate(), 2));
        setAnoBloqueado(pickDate.getFullYear());
        setMesBloqueado(addZeroes(pickDate.getMonth() + 1, 2));
        setDiaBloqueado(addZeroes(pickDate.getDate(), 2));
        setNotificationType(1);
        setComprovanteEnviado(true)
        setcomprovanteLogin(login)
        setcomprovanteSenha(senha)
        setcomprovanteGrupo(grupo)
        getClienteDetails(ClienteId)
        clearData();
      } else {
        setNotificationType(2);
      }
    } else {
      setNotificationType(3);
    }
  }
  const clearData = () => {
    let checkBox1 = document.getElementById("checkBox1");
    let checkBox2 = document.getElementById("checkBox2");
    let checkBox3 = document.getElementById("checkBox3");
    let checkBox4 = document.getElementById("checkBox4");
    let checkBox5 = document.getElementById("checkBox5");
    checkBox1.checked = false;
    checkBox2.checked = false;
    checkBox3.checked = false;
    checkBox4.checked = false;
    checkBox5.checked = false;
    setLogin("");
    setSenha("");
    setPais("pt-br");
    setConta("");
    setVendedor("");
    setCidade([]);
    setLimiteAntecedencia("");
    setObs("");
    setGrupo("");
    setStatus(0);
  }
  /* Adiciona as cidades em um array conforme elas são marcadas e desmarcadas na checkbox */
  const arrayOfCity = (city, id) => {
    let checkBox1 = document.getElementById("checkBox1");
    let checkBox2 = document.getElementById("checkBox2");
    let checkBox3 = document.getElementById("checkBox3");
    let checkBox4 = document.getElementById("checkBox4");
    let checkBox5 = document.getElementById("checkBox5");
    if (id === 1) {
      if (checkBox1.checked === true) {
        setCidade([...cidade, city]);
      } else {
        setCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 2) {
      if (checkBox2.checked === true) {
        setCidade([...cidade, city]);
      } else {
        setCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 3) {
      if (checkBox3.checked === true) {
        setCidade([...cidade, city]);
      } else {
        setCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 4) {
      if (checkBox4.checked === true) {
        setCidade([...cidade, city]);
      } else {
        setCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 5) {
      if (checkBox5.checked === true) {
        setCidade([...cidade, city]);
      } else {
        setCidade(v => v.filter(cidade => cidade !== city));
      }
    }
  }
  const newArrayOfCity = (city, id) => {
    let newCheckBox1 = document.getElementById("newCheckBox1");
    let newCheckBox2 = document.getElementById("newCheckBox2");
    let newCheckBox3 = document.getElementById("newCheckBox3");
    let newCheckBox4 = document.getElementById("newCheckBox4");
    let newCheckBox5 = document.getElementById("newCheckBox5");
    if (id === 1) {
      if (newCheckBox1.checked === true) {
        setNewCidade([...newCidade, city]);
      } else {
        setNewCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 2) {
      if (newCheckBox2.checked === true) {
        setNewCidade([...newCidade, city]);
      } else {
        setNewCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 3) {
      if (newCheckBox3.checked === true) {
        setNewCidade([...newCidade, city]);
      } else {
        setNewCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 4) {
      if (newCheckBox4.checked === true) {
        setNewCidade([...newCidade, city]);
      } else {
        setNewCidade(v => v.filter(cidade => cidade !== city));
      }
    } else if (id === 5) {
      if (newCheckBox5.checked === true) {
        setNewCidade([...newCidade, city]);
      } else {
        setNewCidade(v => v.filter(cidade => cidade !== city));
      }
    }
  }
  const [usuariosDuplicados, setUsuariosDuplicados] = useState([]);
  useEffect(() => {
    const usuariosDuplicadosProvisorio = [];
    for (var i = 0; i < usersList.length; i++) {
      for (var y = i + 1; y < usersList.length; y++) {
        if (usersList[i].login === usersList[y].login && usersList[i].id !== usersList[y].id) {
          if (!usuariosDuplicadosProvisorio.some(user => user.id === usersList[i].id)) {
            usuariosDuplicadosProvisorio.push(usersList[i]);
          }
          if (!usuariosDuplicadosProvisorio.some(user => user.id === usersList[y].id)) {
            usuariosDuplicadosProvisorio.push(usersList[y]);
          }
        }
      }
    }
    usuariosDuplicadosProvisorio.sort(function (a, b) {
      return a.login.localeCompare(b.login);
    });
    setUsuariosDuplicados(usuariosDuplicadosProvisorio);
  }, [usersList]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterLogin, setFilterLogin] = useState('');
  /////////////////////////////////
  useEffect(() => {
    // SE A PESSOA TENTAR PROCURAR ALGUEM APARECER TODOS!
    if (filterLogin !== '') {
      setFilteredData(usersList.filter((items) => items.login.toLowerCase().includes(filterLogin.toLowerCase())));
    }
    else if (filtroCidade == -1 && filtroGrupo == -1 && filtroStatus == -1) {
      setFilteredData(usersList.filter((items) => items.status == 0));
    }
    else if (filtroCidade == -1 && filtroGrupo == -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.status == filtroStatus));
    }
    else if (filtroCidade == -1 && filtroGrupo != -1 && filtroStatus == -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo));
    }
    else if (filtroCidade != -1 && filtroGrupo == -1 && filtroStatus == -1) {
      setFilteredData(filteredData.filter((items) => items.cidade.includes(filtroCidade)))
    }
    else if (filtroCidade == -1 && filtroGrupo != -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.status == filtroStatus));
    }
    else if (filtroCidade != -1 && filtroGrupo == -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.status == filtroStatus && items.cidade.includes(filtroCidade)));
    }
    else if (filtroCidade != -1 && filtroGrupo != -1 && filtroStatus == -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.cidade.includes(filtroCidade)));
    }
    else if (filtroCidade != -1 && filtroGrupo != -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.cidade.includes(filtroCidade) && items.status == filtroStatus));
    }
  }, [usersList, filterLogin, filtroCidade, filtroGrupo, filtroStatus, userIdMonitorar,]);  /////////////////////////////////

  function copyTextToClipboard(text) {
    const input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }
  function copyDataAtivo() {
    copyTextToClipboard(listaClientesAtivos);
    setNotificationType(11);
  }
  function copyDataHibernado() {
    copyTextToClipboard(listaClientesHibernados);
    setNotificationType(11);
  }
  function copyDataFinalizado() {
    copyTextToClipboard(listaClientesFinalizados);
    setNotificationType(11);
  }
  async function getClientDataAtivo() {
    const res = await api.get('/getDataAtivo');
    let jsonString = JSON.stringify(res.data);
    let jsonObject = JSON.parse(jsonString);
    // jsonObject.cidade = jsonObject.cidade[0].split(", ");
    let modifiedString = JSON.stringify(jsonObject).replace(/"([^"]+)":/g, '$1:');
    setListaClientesAtivos("const persons = " + modifiedString);
  }
  async function getClientDataHibernando() {
    const res = await api.get('/getDataHibernando');
    let jsonString = JSON.stringify(res.data);
    let jsonObject = JSON.parse(jsonString);
    let modifiedString = JSON.stringify(jsonObject).replace(/"([^"]+)":/g, '$1:');
    setListaClientesHibernados("const quarentena = " + modifiedString);
  }
  async function getClientDataFinalizado() {
    const res = await api.get('/getDataFinalizado');
    let jsonString = JSON.stringify(res.data);
    let jsonObject = JSON.parse(jsonString);
    let modifiedString = JSON.stringify(jsonObject).replace(/"([^"]+)":/g, '$1:');
    setListaClientesFinalizados("const finalista = " + modifiedString);
  }
  function mudarTextoBotao() {
    if (estadoDuplicados) {
      setTextoBotaoDuplicados("Exibir Duplicados");
      return;
    }
    setTextoBotaoDuplicados("Ocultar Duplicados");
  }
  async function descerItem(user, nextUser) {
    const res = await api.post('/descerItem', {
      user: user,
      nextUser: nextUser
    });
    if (res.data.status === false) {
      setNotificationType(16);
    } else {

      getUsers()
    }
  }
  async function subirItem(user, backUser) {
    const res = await api.post('/subirItem', {
      user: user,
      backUser: backUser
    });
    if (res.data.status === false) {
      setNotificationType(15);
    } else {
      getUsers()
    }
  }
  async function enviarParaInicio(user) {
    const res = await api.post('/enviarParaInicio', {
      user: user
    });
    if (res.data.status === false) {
      setNotificationType(18);
    } else {
      getUsers()
    }
  }
  async function enviarParaFim(user, tamanhoTotalLista) {
    const res = await api.post('/enviarParaFim', {
      user: user,
      tamanhoTotalLista: tamanhoTotalLista
    });
    if (res.data.status === false) {
      setNotificationType(17);
    } else {
      getUsers()
    }
  }

  const handleToggleShowAll = () => {
    setShowAllClientes(prevState => !prevState);
  };

  const [clienteIdSelecionado, setClienteIdSelecionado] = useState(null);
  const handleClienteSelecionado = (clienteId) => {
    setClienteId(clienteId);
    console.log('Cliente selecionado ID:', clienteId);
  };

  async function handleClienteCriado(novoCliente) {
    setClientesList((prevList) => [...prevList, novoCliente]); // Atualiza a lista com o novo cliente
    console.log("CLIENTE CRIADO id: " + novoCliente.id)
    handleClienteSelecionado(novoCliente.id); // Seleciona automaticamente o cliente recém-criado
    setClienteId(novoCliente.id)
  }

  const handleClick = async (user) => {
    try {
      console.log(`Verificando agendamento para cliente_id: ${user.id}`); // Log do cliente_id
      const response = await api.get(`/agendamento/${user.id}`);
      console.log('Resposta da API:', response.data); // Log da resposta da API
      let AgendamentoInicial;
      let isEditMode = false; // Inicializa o modo de edição como falso

      if (response.data.length > 0) {
        const agendamento = response.data[0];
        console.log("agenda")
        console.log(agendamento)



        console.log("user")
        console.log(user.ClienteId)


        AgendamentoInicial = {
          // consuladoCasv: agendamento.casv ? JSON.parse(agendamento.casv).consulado : '',
          // dataHorarioCasv: agendamento.casv ? JSON.parse(agendamento.casv).data_horario : '',
          consuladoEntrevista: agendamento.entrevista ? JSON.parse(agendamento.entrevista).consulado : '',
          dataHorarioEntrevista: agendamento.entrevista ? JSON.parse(agendamento.entrevista).data_horario : '',
          aprovado: agendamento.aprovado,
          clienteId: parseInt(agendamento.cliente_id, 10),
          idDoCliente: user.ClienteId, // Inclui o id do cliente
          id: agendamento.id,
          email: user.login, // Inclui o e-mail do usuário no agendamento inicial
          nome: user.clienteNome,
          vendedor: user.vendedor,
          contato: user.clienteContato,
        };
        isEditMode = true; // Define como verdadeiro se há dados no agendamento
        console.log("achei")

      } else {
        console.log("nao achei")
        const now = new Date();
        const formattedDateTime = now.toISOString().slice(0, 16); // Formata como 'YYYY-MM-DDTHH:mm'

        AgendamentoInicial = {
          consuladoEntrevista: '',
          dataHorarioEntrevista: formattedDateTime, // Define a data e hora atuais
          aprovado: false,
          clienteId: parseInt(user.id, 10),
          email: user.login, // Inclui o e-mail do usuário no novo agendamento
          nome: user.clienteNome,
          idDoCliente: user.ClienteId, // Inclui o id do cliente
          contato: user.clienteContato,
          vendedor: user.vendedor,
          obs: user.obs,
        };

      }
      console.log("Agendamento Inicial222:", AgendamentoInicial); // Log do agendamento inicial
      console.log(AgendamentoInicial); // Log do modo de edição

      openModal(AgendamentoInicial, isEditMode); // Passa isEditMode para a função openModal
    } catch (error) {
      console.error('Erro ao verificar agendamento:', error);
    }
  };

  return (
    <div className={styles.app}>
      <NotificationContainer />
      <Agendamentos />

      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>CLIENTES</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <CreateCliente clientesList={clientesList} handleToggleShowAll={handleToggleShowAll} showAllClientes={showAllClientes} parceirosList={parceirosList} onClienteSelecionado={handleClienteSelecionado} onClienteCriado={handleClienteCriado} />
      </div>


      <div className={`${styles.corTitulo} ${styles.red}`}>
        <p className={styles.titulo}>MONITORAR</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <div className={styles.containerTituloInput}>
          <input className={styles.inputFilter} style={{width: "90%", marginTop: "10px"}} type="text" onChange={(e) => setLogin(e.target.value)} value={login} placeholder="Digite o Email" />
          <input className={styles.inputFilter} style={{width: "90%"}}  type="text" onChange={(e) => setSenha(e.target.value)} value={senha} placeholder="Digite a senha" />
        </div>
        <div className={styles.containerVendedorInput}>
          <div className={styles.containerVendedor}>
            {/* <div className={styles.containerTituloInput}> */}
            <p className={styles.inputText}>VENDEDOR: </p>


            <select
              onChange={(e) => {
                console.log('Vendedor selecionado:', e.target.value);
                setVendedor(e.target.value);
              }}
              value={vendedor}
              className={styles.inputFilter} 
            >
              <option value="">Selecione um Vendedor</option>
              {vendedoresList.map((v) => (
                <option key={v.id} value={v.cpf}>
                  {v.nome} - {v.cpf}
                </option>
              ))}
            </select>


          </div>
        </div>
        <div className={styles.divisor}></div>
        {/* Parte 02 cadastro */}
        <div className={styles.cadastroItems02}>
          <p className={styles.inputTextTitle}>Consulados Dispoíveis*</p>
          <div className={styles.groupCityContainer}>
            <div className={styles.containerCidades} >
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox1" type="checkbox" onChange={() => arrayOfCity("54", 1)} name="translateRadio" />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Brasília</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox2" type="checkbox" onChange={() => arrayOfCity("56", 2)} name="translateRadio" />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>São Paulo</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox3" type="checkbox" onChange={() => arrayOfCity("128", 3)} name="translateRadio" />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Porto Alegre</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox4" type="checkbox" onChange={() => arrayOfCity("55", 4)} name="translateRadio" />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Rio de Janeiro</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox5" type="checkbox" onChange={() => arrayOfCity("57", 5)} name="translateRadio" />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Recife</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.divisor}></div>
        {/* Parte 03 cadastro */}
        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dias de Antecedência*</p>
            <input className={styles.inputFilter} style={{width: "60px"}}  type="text" onChange={(e) => setLimiteAntecedencia(e.target.value)} value={limiteAntecedencia} placeholder="Limite de antecedência" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>País</p>
            <select onChange={(e) => setPais(e.target.value)} value={pais} className={styles.inputFilter} style={{width: "160px"}}>
              {countriesList.map(items => {
                return (
                  <option key={items.country} value={items.country}>{items.country}</option>
                )
              })}
            </select>
          </div>
        </div>
        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Data limite</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setAnoMarcado(e.target.value)} value={anoMarcado} placeholder="Digite o ano" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Mês</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setMesMarcado(e.target.value)} value={mesMarcado} placeholder="Digite o mês" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dia</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setDiaMarcado(e.target.value)} value={diaMarcado} placeholder="Digite o dia" />
          </div>
        </div>
        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Data inicio</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setAnoBloqueado(e.target.value)} value={anoBloqueado} placeholder="Digite o ano" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Mês</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setMesBloqueado(e.target.value)} value={mesBloqueado} placeholder="Digite o mês" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dia</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setDiaBloqueado(e.target.value)} value={diaBloqueado} placeholder="Digite o dia" />
          </div>
        </div>
        <div className={styles.divisor}></div>
        {/* Parte 04 cadastro */}
        <div className={styles.cadastroItems04}>
          <div className={styles.itemContainer}>
            <p className={styles.inputText}>Observações</p>
            <textarea onChange={(e) => setObs(e.target.value)} value={obs} className={styles.inputFilter} style={{width: "90%", height: "auto", minHeight:"200px"}} placeholder="Digite uma observação" ></textarea>
          </div>
        </div>
        <div className={styles.divisor}></div>
        {/* Parte 05 cadastro */}
        <div className={styles.cadastroItems05}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Grupo*</p>
            <input className={styles.inputFilter} style={{width: "60px"}} type="text" onChange={(e) => setGrupo(e.target.value)} value={grupo} placeholder="1 ou 2" />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Status</p>
            <select onChange={e => setStatus(e.target.value)} value={status} className={styles.inputFilter} style={{width: "160px"}}name="" id="">
              <option value={0}>Ativo</option>
              <option value={1}>Quarentena</option>
              <option value={2}>Finalista</option>
              <option value={3}>Senha errada</option>
              <option value={4}>Garantido</option>
              <option value={5}>Pagar taxa</option>
            </select>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button onClick={() => (insertData())} className={styles.cadastroCliente}>
            MONITORAR
          </button>
        </div>
      </div>
      {comprovanteEnviado === true ?
        <div className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
          onClick={() => {
            var r = document.createRange();
            r.selectNode(document.getElementById('copiar'));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(r);
            try {
              document.execCommand('copy');
              window.getSelection().removeAllRanges();
              console.log('Successfully copy text:' + r);
              setNotificationType(19);
            } catch (err) {
              console.log('Unable to copy!');
            }
          }} >
          <div className={styles.copiarTop}>
            COMPROVANTE (clica para copiar)
          </div>
          <p id='copiar' className={styles.copiarText} >
            Nome: {nomeClienteComprovante}
            < br />
            Contato: {contatoClienteComprovante}
            < br />
            < br />
            {comprovanteLogin}
            < br />
            {comprovanteSenha}
            < br />
            < br />
            {comprovanteAnoMarcado}-{comprovanteMesMarcado}-{comprovanteDiaMarcado} à {comprovanteAnoBloqueado}-{comprovanteMesBloqueado}-{comprovanteDiaBloqueado}
            < br />
            {comprovanteGrupo} | {revelarNomesCidades(comprovanteCidade)}
            < br />
            Antecedência mínima: {comprovanteLimiteAntecedencia}
            < br />
            obs: {comprovanteObs}
            < br />
            < br />
            Status: {comprovanteStatus}
          </p>
        </div>
        :
        <></>
      }
      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Fila de monitoramento</p>
      </div>
      {/* Edição de Clientes */}
      <div className={styles.cadastroClienteContainer}>
        <div className={styles.tituloContainer}>
        </div>
        <div className={styles.divisor}></div>
        {/* Filtro de Clientes */}
        <div className={styles.filtroDeClientesContainer}>
          <div className={styles.containerTituloInput}>
            <input className={`${styles.inputStyle} ${styles.inputFilter}`} type="text" onChange={(e) => setFilterLogin(e.target.value)} value={filterLogin} placeholder="Digite o login do usuário que deseja encontrar!" />
          </div>
          <div className={styles.filterOptionsContainer}>
            <div>
              <select className={`${styles.inputStyleMin} ${styles.inputSpacing}`} onChange={e => { setFiltroGrupo(e.target.value); }}>
                <option value={-1}>Grupo</option>
                <option value={1}>Individual</option>
                <option value={2}>Coletivo</option>
              </select>
            </div>
            <div>
              <select className={styles.inputStyleMin} onChange={e => { setFiltroCidade(e.target.value); }}>
                <option value={-1}>Cidade</option>
                <option value={54}>Brasília</option>
                <option value={56}>São Paulo</option>
                <option value={128}>Porto Alegre</option>
                <option value={55}>Rio de Janeiro</option>
                <option value={57}>Recife</option>
              </select>
            </div>
            <div>
              <select className={`${styles.inputStyleMin} ${styles.inputSpacing}`} onChange={e => { setFiltroStatus(e.target.value); }}>
                <option value={0}>Ativos</option>
                <option value={1}>Quarentena</option>
                <option value={2}>Finalistas</option>
                <option value={3}>Senha errada</option>
                <option value={4}>Garantido</option>
                <option value={5}>Pagar taxa</option>
              </select>
            </div>
          </div>
        </div>
        <div className={styles.divisor}></div>
        <div className={styles.usersListContainer}>
          {filteredData.map((user, index) => {
            const nextUser = filteredData[index + 1];
            const backUser = filteredData[index - 1];
            const tamanhoTotalLista = filteredData.length;

            // Parse JSON entrevista e formata a data
            let dataHorarioEntrevista = '';
            if (user.entrevista) {
              try {
                const entrevista = JSON.parse(user.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(parseISO(entrevista.data_horario), 'dd-MM-yy');
                }
              } catch (error) {
                console.error('Erro ao parsear entrevista:', error);
              }
            }

            // Busca o nome do vendedor pelo CPF
            const vendedor = vendedoresList.find(v => v.cpf === user.vendedor);
            const vendedorNome = vendedor ? vendedor.nome : 'Vendedor não encontrado';

            return (
              <div key={user.id} className={styles.userContainer}>
                <div className={styles.userContainer2}>
                  <div className={styles.onOffIconContainer}>
                    <div className={user.status === 0 ? styles.groupAmountVerde : styles.groupAmountVermelho}>
                      <p className={styles.icon}>{user.grupo}</p>
                    </div>
                  </div>
                  <div className={styles.loginContainer}>
                    <p>{user.login} - </p>
                    {user.vendedor !== 0 ? (
                      <p className={styles.icon2}>
                        {vendedorNome}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className={styles.iconeslat}>
                  <div className={styles.editContainer}>
                    <p style={{ padding: "10px", backgroundColor: "var(--corPrimaria)", borderRadius: "10px", color: "white", fontSize: "1.2rem" }}>
                      {dataHorarioEntrevista.split('T')[0]}
                    </p>
                    <div
                      onClick={() => {
                        setOpenCloseEditStatus(!openCloseEditStatus);
                        sendItemsToEdit(user);
                        console.log("user: ", user);
                      }}
                      className={styles.editIconBox}
                      style={{ backgroundColor: "var(--corPrimaria)" }}
                    >
                      <p className={styles.icon2}><FaPencilAlt /></p>
                    </div>
                    <div className={`${styles.editIconBox} ${styles.yellow}`} onClick={() => handleClick(user)}>
                      <p className={styles.icon2}><FaExclamation /></p>
                    </div>
                    <div className={`${styles.editIconBox}`} style={{ backgroundColor: "var(--corPrimaria)" }}>
                      <div className={styles.deleteContainer}>
                        <Usuarios
                          user={user}
                          nextUser={nextUser}
                          backUser={backUser}
                          descerItem={descerItem}
                          subirItem={subirItem}
                          enviarParaFim={enviarParaFim}
                          enviarParaInicio={enviarParaInicio}
                          tamanhoTotalLista={tamanhoTotalLista}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.userContainer1}>
                  <div className={styles.obsContainer}>
                    <p>{user.obs}</p>
                  </div>
                  <div className={styles.obsContainer}>
                    <p>{user.cidade}</p>
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      </div>
      <div>
        <button className={styles.mostrarDuplicados} onClick={() => (setEstadoDuplicados(!estadoDuplicados), mudarTextoBotao())}>{textoBotaoDuplicados}</button>
      </div>
      {/* Edição de Clientes */}
      {estadoDuplicados === true ?
        <div className={styles.cadastroClienteContainer}>
          <div className={styles.tituloContainer}>
            <p className={styles.titulo}>Lista de Duplicados</p>
          </div>
          <div className={styles.divisor}></div>
          <div className={styles.usersListContainer}>
            {usuariosDuplicados.map(user => {
              return (
                <div key={user.id} className={styles.userContainer}>
                  <div className={styles.onOffIconContainer}>
                    <div className={user.status === 0 ? styles.groupAmountVerde : styles.groupAmountVermelho}>
                      <p className={styles.icon}>{user.grupo}</p>
                    </div>
                  </div>
                  <div className={styles.loginContainer}>
                    <p>{user.login}</p>
                  </div>
                  <div className={styles.iconeslat}>
                    <div className={styles.editContainer}>
                      <div onClick={() => (setOpenCloseEditStatus(!openCloseEditStatus), sendItemsToEdit(user))} className={styles.editIconBox}>
                        <p className={styles.icon2}><FaPencilAlt /></p>
                      </div>
                    </div>


                    <div className={styles.deleteContainer}>
                      <div onClick={() => deleteUser(user.id)} className={styles.deleteIconBox}>
                        <p className={styles.icon2}><FaTrashAlt /></p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        :
        <></>
      }
      {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
      {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
      {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
      {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}



 {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
      
      <div className={`${styles.corTitulo} ${styles.bluea}`}>
            <p className={styles.titulo}>Listas de Clientes</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <div className={styles.tituloContainer}>
          {/* <p className={styles.titulo}>Captura de Clientes</p> */}
        </div>
        <div>
          <p className={styles.topText}><strong>Ativos</strong></p>
          <input className={`${styles.inputStyle} ${styles.inputFilter}`} value={listaClientesAtivos} type="text" />
        </div>
        <div className={styles.buttonsGroup}>
          <button className={styles.buttonMenor} onClick={getClientDataAtivo}>Atualizar</button>
          <button className={styles.buttonMenor} onClick={copyDataAtivo}>Copiar</button>
        </div>


        {/* <div>
          <p className={styles.topText}><strong>Hibernando</strong></p>
          <input className={`${styles.inputStyle} ${styles.inputFilter}`} value={listaClientesHibernados} type="text" />
        </div>
        <div className={styles.buttonsGroup}>
          <button className={styles.buttonMenor} onClick={getClientDataHibernando}>Atualizar</button>
          <button className={styles.buttonMenor} onClick={copyDataHibernado}>Copiar</button>
        </div>
        <div>
          <p className={styles.topText}><strong>Finalizados</strong></p>
          <input className={`${styles.inputStyle} ${styles.inputFilter}`} value={listaClientesFinalizados} type="text" />
        </div>
        <div className={styles.buttonsGroup}>
          <button className={styles.buttonMenor} onClick={getClientDataFinalizado}>Atualizar</button>
          <button className={styles.buttonMenor} onClick={copyDataFinalizado}>Copiar</button>
        </div> */}


      </div>
      {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------- */}

      {openCloseEditStatus === true ?
        <div className={styles.backgroundBlur}>
          <div className={styles.generalContainer}>
            <div onClick={() => setOpenCloseEditStatus(!openCloseEditStatus)} className={styles.closeButton}>
              <p className={styles.icon}><IoCloseSharp /></p>
            </div>
            <div className={`${styles.cadastroClienteContainer} ${styles.cadastroClienteContainerWithoutMargin}`}>
              <div className={styles.divisor}></div>
              {/* Parte 01 cadastro */}
              <div className={styles.cadastroItems01}>
                <div className={styles.containerTituloInput}>
                  <input className={styles.inputStyle} type="text" onChange={(e) => setNewLogin(e.target.value)} value={newLogin} placeholder="Digite o Email" />
                </div>
                <div className={styles.containerTituloInput}>
                  <input className={styles.inputStyle} type="text" onChange={(e) => setNewSenha(e.target.value)} value={newSenha} placeholder="Digite a senha" />
                </div>
                <div className={styles.containerVendedorInput}>
                  <div className={styles.containerVendedor}>
                    <p className={styles.inputText}>VENDEDOR: </p>



                    <select
                      onChange={(e) => {
                        console.log('Vendedor selecionado:', e.target.value);
                        setNewVendedor(e.target.value);
                      }}
                      value={newVendedor}
                      className={styles.inputStyleVendedor}
                    >
                      <option value="">Selecione um Vendedor</option>
                      {vendedoresList.map((v) => (
                        <option key={v.id} value={v.cpf}>
                          {v.nome} - {v.cpf}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>
              </div>
              {/* Parte 02 cadastro */}
              <div className={styles.cadastroItems02}>
                <div className={styles.groupCityContainer}>
                  <div className={styles.containerCidades} >
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox1" type="checkbox" onChange={() => newArrayOfCity("54", 1)} name="translateRadio" />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Brasília</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox2" type="checkbox" onChange={() => newArrayOfCity("56", 2)} name="translateRadio" />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>São Paulo</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox3" type="checkbox" onChange={() => newArrayOfCity("128", 3)} name="translateRadio" />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Porto Alegre</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox4" type="checkbox" onChange={() => newArrayOfCity("55", 4)} name="translateRadio" />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Rio de Janeiro</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox5" type="checkbox" onChange={() => newArrayOfCity("57", 5)} name="translateRadio" />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Recife</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.divisor}></div>
              {/* Parte 03 cadastro */}
              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dias de Antecedência*</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewLimiteAntecedencia(e.target.value)} value={newLimiteAntecedencia} placeholder="Digite o limite de antecedência" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>País</p>
                  <select onChange={(e) => setNewPais(e.target.value)} value={newPais} className={styles.selectStyle}>
                    {countriesList.map(items => {
                      return (
                        <option key={items.country} value={items.country}>{items.country}</option>
                      )
                    })}
                  </select>
                </div>
              </div>
              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Data limite</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewAnoMarcado(e.target.value)} value={newAnoMarcado} placeholder="Digite o ano" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Mês</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewMesMarcado(e.target.value)} value={newMesMarcado} placeholder="Digite o mês" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dia</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewDiaMarcado(e.target.value)} value={newDiaMarcado} placeholder="Digite o dia" />
                </div>
              </div>
              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Data inicio</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewAnoBloqueado(e.target.value)} value={newAnoBloqueado} placeholder="Digite o ano" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Mês</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewMesBloqueado(e.target.value)} value={newMesBloqueado} placeholder="Digite o mês" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dia</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewDiaBloqueado(e.target.value)} value={newDiaBloqueado} placeholder="Digite o dia" />
                </div>
              </div>
              <div className={styles.divisor}></div>
              {/* Parte 04 cadastro */}
              <div className={styles.cadastroItems04}>
                <div className={styles.itemContainer}>
                  <p className={styles.inputText}>Observações</p>
                  <textarea onChange={(e) => setNewObs(e.target.value)} value={newObs} className={styles.textArea} placeholder="Digite uma observação" ></textarea>
                </div>
              </div>
              <div className={styles.divisor}></div>
              {/* Parte 05 cadastro */}
              <div className={styles.cadastroItems05}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Grupo*</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewGrupo(e.target.value)} value={newGrupo} placeholder="1 ou 2" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Status</p>
                  <select onChange={e => setNewStatus(e.target.value)} value={newStatus} className={styles.inputStyleMin} name="" id="">
                    <option value={0}>Ativo</option>
                    <option value={1}>Quarentena</option>
                    <option value={2}>Finalista</option>
                    <option value={3}>Senha errada</option>
                    <option value={4}>Garantido</option>
                    <option value={5}>Pagar taxa</option>
                  </select>
                </div>
              </div>
              <div className={styles.buttonContainer}>
                <button onClick={() => {
                  updateNewData(userIdMonitorar, newStatus)
                  getUsers()
                }} className={styles.cadastroCliente}>Salvar Alterações</button>
              </div>
            </div>
          </div>
        </div>
        :
        <></>
      }
      <div className={styles.rodape}>
        {/* <p className={styles.rodapeText}>&copy; Todos os direitos reservados - Agiliza Visto 2023</p> */}
      </div>
    </div>
  );
}


export default Monitorar;